<template>
  <div class="container">
    <h1>Restore configuration</h1>
    <b-table
        :narrowed="true"
        :striped="true"
        :data="data">
      <template slot-scope="props">
        <b-table-column label="#" numeric field="num">{{props.row.num}}</b-table-column>
        <b-table-column label="File" field="hft">{{props.row.hft}}</b-table-column>
        <b-table-column numeric>
          <b-button type="is-info"
                    class="is-small is-outlined"
                    v-if="isDevelopmentMode"
                    @click="handleDownload(props.row.name)"
                    style="margin-right: 0.5rem;"
          >Download</b-button>
            <b-button type="is-danger" class="is-small is-outlined" style="margin-right: 0.5rem;" @click="handleDeleteBackup(props.row.name)">Delete backup</b-button>
            <b-button type="is-primary" class="is-small" @click="handleClickRestore(props.row.name)">Restore</b-button>
        </b-table-column>
      </template>
    </b-table>
  </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex';
  import BTable from "buefy/src/components/table/Table";
  import BTableColumn from "buefy/src/components/table/TableColumn";
  import BButton from "buefy/src/components/button/Button";

  export default {
    name: "screenconfigurerestore",
    components: {
      BButton,
      BTableColumn,
      BTable

    },
    data() {
      return {};
    },
    computed: {
      ...mapGetters('auth', ['dumpFiles']),
      data() {
        const ret = [];
        if (!this.dumpFiles) {
          return [];
        }

        let num = 0;

        this.dumpFiles.forEach(item => {
          num++;
          ret.push({
            name: item,
            hft: item.replace(/^dump-/, ''),
            num
          });
        });

        return ret;
      },
      isDevelopmentMode: () => {
        return process.env.NODE_ENV === "development";
      }
    },
    methods: {
      ...mapActions('auth', ['postRestore', 'deleteBackup', 'downloadBackup', 'postRestart']),
      handleClickRestore(fileName) {
        if (confirm('Are you sure ?')) {
          this.postRestore({
            fileName: fileName,
            cb: () => {
              this.postRestart();
            }
          });
        }
      },
      handleDeleteBackup(fileName) {
        if (confirm("Are you sure ? You might lose data...")) {
          this.deleteBackup(btoa(fileName));
        }
      },
      handleDownload(fileName) {
        this.downloadBackup(btoa(fileName));
      }
    }
  }
</script>

<style scoped>
  h1 {
    font-size: 1.5rem;
    font-weight: bold;
    margin-top: 0.75rem;
    margin-bottom: 0.75rem;
  }

  .margin_top_1rem {
    margin-top: 1rem;
  }

  .margin_bottom_1rem {
    margin-bottom: 1rem;
  }

  .margin_bottom_2rem {
    margin-bottom: 2rem;
  }
</style>